import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Map, Wifi, CreditCard, Languages, Calendar } from 'lucide-react';
export function SolutionSection() {
  return <section className="py-14 lg:py-24 px-4 sm:px-6 lg:px-8 bg-cream overflow-hidden relative" data-id="element-243">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-5 pointer-events-none" style={{
      backgroundImage: 'radial-gradient(#C5A55A 1px, transparent 1px)',
      backgroundSize: '30px 30px'
    }} data-id="element-244"></div>

      <div className="max-w-7xl mx-auto" data-id="element-245">
        <div className="text-center mb-10 lg:mb-16" data-id="element-246">
          <span className="text-china-red font-bold tracking-wider text-sm uppercase mb-2 block" data-id="element-247">
            La Solución
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-charcoal mb-4 lg:mb-6" data-id="element-248">
            Kit Anti‑Bloqueo + Rutas por Módulos
          </h2>
          <p className="text-base lg:text-xl text-charcoal-light max-w-2xl mx-auto" data-id="element-249">
            Esto no es "otra guía de China". Es un manual operativo para que el
            viaje{' '}
            <span className="font-semibold text-china-red" data-id="element-250">no se atasque</span>.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-20 items-center" data-id="element-251">
          {/* Left: Kit Anti-Bloqueo */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7
        }} className="bg-white p-6 sm:p-8 lg:p-10 rounded-2xl shadow-xl border-t-4 border-china-red relative" data-id="element-252">
            <div className="absolute -top-5 left-6 lg:-top-6 lg:left-8 bg-china-red text-white px-3 py-1.5 lg:px-4 lg:py-2 rounded-lg shadow-md font-serif font-bold text-base lg:text-lg" data-id="element-253">
              Parte 1
            </div>

            <h3 className="text-2xl font-bold text-charcoal mb-2 mt-2" data-id="element-254">
              Kit Anti‑Bloqueo
            </h3>
            <p className="text-charcoal-light mb-5 lg:mb-8 italic" data-id="element-255">
              Lo mínimo que lo cambia todo
            </p>

            <ul className="space-y-3 lg:space-y-5" data-id="element-256">
              {[{
              icon: Wifi,
              text: 'Conectividad (A + Plan B)'
            }, {
              icon: CreditCard,
              text: 'Pagos móviles + backup'
            }, {
              icon: Map,
              text: 'Mapas y navegación (favoritos + direcciones guardadas)'
            }, {
              icon: Languages,
              text: 'Traducción para resolver (no para hablar perfecto)'
            }, {
              icon: ShieldCheck,
              text: 'Reservas críticas (sin ansiedad)'
            }].map((item, i) => <li key={i} className="flex items-center" data-id="element-257">
                  <div className="flex-shrink-0 h-8 w-8 lg:h-10 lg:w-10 rounded-full bg-cream flex items-center justify-center mr-3 lg:mr-4 text-china-red" data-id="element-258">
                    <item.icon className="h-4 w-4 lg:h-5 lg:w-5" data-id="element-259" />
                  </div>
                  <span className="text-charcoal font-medium" data-id="element-260">{item.text}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Right: Rutas por Módulos */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7,
          delay: 0.2
        }} className="bg-white p-6 sm:p-8 lg:p-10 rounded-2xl shadow-xl border-t-4 border-gold relative" data-id="element-261">
            <div className="absolute -top-5 left-6 lg:-top-6 lg:left-8 bg-gold text-white px-3 py-1.5 lg:px-4 lg:py-2 rounded-lg shadow-md font-serif font-bold text-base lg:text-lg" data-id="element-262">
              Parte 2
            </div>

            <h3 className="text-2xl font-bold text-charcoal mb-2 mt-2" data-id="element-263">
              Rutas por Módulos
            </h3>
            <p className="text-charcoal-light mb-5 lg:mb-8 italic" data-id="element-264">
              Ciudades como piezas Lego
            </p>

            <p className="mb-4 lg:mb-6 text-charcoal/80 text-sm lg:text-base" data-id="element-265">
              En lugar de un itinerario rígido, eliges módulos y los combinas
              según tus días:
            </p>

            <div className="space-y-2 lg:space-y-3" data-id="element-266">
              {['Pekín (3–5 días)', 'Shanghái + Suzhou + Hangzhou (4–7)', 'Chengdu (2–4)', 'Guilin + Yangshuo (3–5)', 'Hong Kong (2–4)', '+ extras (Xi’an, Zhangjiajie, Shenzhen…)'].map((city, i) => <div key={i} className="flex items-center p-2.5 lg:p-3 bg-off-white rounded-lg border border-gray-100" data-id="element-267">
                  <Calendar className="h-4 w-4 text-gold mr-3 flex-shrink-0" data-id="element-268" />
                  <span className="text-charcoal font-medium" data-id="element-269">{city}</span>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}